import * as Sentry from '@sentry/gatsby';

declare const TARGET: string;
declare const VERSION: string;

const enabled = TARGET === 'prod';
if (enabled) {
  Sentry.init({
    dsn: 'https://97631278f3697adb20bb7f405be2f541@o478484.ingest.us.sentry.io/4507701989408768',
    enabled,
    release: VERSION,
    integrations: [
      Sentry.thirdPartyErrorFilterIntegration({
        // Specify the application keys that you specified in the Sentry bundler plugin
        filterKeys: ['sentry-boka-customer-key'],
        // Defines how to handle errors that contain third party stack frames.
        // Possible values are:
        // - 'drop-error-if-contains-third-party-frames'
        // - 'drop-error-if-exclusively-contains-third-party-frames'
        // - 'apply-tag-if-contains-third-party-frames'
        // - 'apply-tag-if-exclusively-contains-third-party-frames'
        behaviour: 'apply-tag-if-contains-third-party-frames',
      }),
    ],
    allowUrls: ['/appointment/'],
    // TODO: commented out for now, as we need to investigate the impact of the
    // changes from integrations and allowUrls.
    // beforeSend(event) {
    //   if (
    //     event.exception &&
    //     event.exception.values &&
    //     event.exception.values.length > 0
    //   ) {
    //     const exception = event.exception.values[0];

    //     if (exception.stacktrace && exception.stacktrace.frames) {
    //       const stackFrames = exception.stacktrace.frames;
    //       const stack = stackFrames.filter(
    //         (frame) => frame.filename && frame.filename.includes('/appointment/'),
    //       );
    //       if (stack.length === 0) {
    //         return null;
    //       }
    //     }
    //   }
    //   return event;
    // },
  });
}
